module.exports = __webpack_public_path__ + "img/photo-0082.21f0cb6f.jpg";